import React__default from 'react';
import MessageBubble from '../../../MessageBubble/index.js';
import MessageBubbleText from '../../../MessageBubbleText/index.js';
import { ConsumerRichCardEvents } from '../../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../../containers/RichCardEventEmitter/index.js';
import HeroWithImage from '../../components/HeroWithImage/index.js';
import CallToAction from '../../components/CallToAction/index.js';
import numeral from 'numeral';
import { InterestedInOrderConsumerMessageComponent } from './InterestedInOrderConsumerMessage.generated.js';
import styles from './styles.css.js';

var SingleLineItem = function SingleLineItem(_a) {
  var lineItem = _a.lineItem,
      selectedVariation = _a.selectedVariation;

  if (lineItem.isGroup) {
    return null;
  }

  var duration = selectedVariation && selectedVariation.sellable.variants[0] && selectedVariation.sellable.variants[0].displayValueHtml;
  return React__default.createElement("div", {
    key: lineItem.id
  }, React__default.createElement("div", {
    className: styles.lineItem
  }, React__default.createElement("span", {
    className: styles.lineItemTitle
  }, lineItem.title, lineItem.source.__typename === 'OrderLineItemBasePriceSource' && duration && "(" + duration + ")"), React__default.createElement("span", {
    className: styles.lineItemPrice
  }, lineItem.unitPrice ? numeral(lineItem.unitPrice.amount).format('$0,0.00') : React__default.createElement("span", {
    className: styles.free
  }, "Free"), lineItem.quantity > 1 && "x " + lineItem.quantity)));
};

var InterestedInOrderConsumerMessage = function InterestedInOrderConsumerMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      richCard = _a.richCard;
  var richCardEventEmitter = useRichCardEventEmitter();
  var orderId = richCard.expertCuratedOrderId;
  return React__default.createElement(InterestedInOrderConsumerMessageComponent, {
    variables: {
      id: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.expertCuratedOrder) {
      var _b = data.expertCuratedOrder,
          order = _b.order,
          variationOptions = _b.variationOptions,
          firstName = _b.curatedFor.firstName;
      var title = order.title,
          primaryImage = order.primaryImage,
          lineItems = order.lineItems,
          totalCostBeforeTax = order.totalCostBeforeTax;
      var selectedVariaiton_1 = variationOptions.find(function (option) {
        return option.selected;
      });
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: primaryImage === null || primaryImage === void 0 ? void 0 : primaryImage.url
      }), React__default.createElement("div", {
        className: styles.content
      }, React__default.createElement("div", {
        className: styles.user
      }, firstName, " has requested this charter:"), title && React__default.createElement("div", {
        className: styles.sellableTitle
      }, title), React__default.createElement("div", null, lineItems.map(function (orderLineItem) {
        return React__default.createElement(SingleLineItem, {
          key: orderLineItem.id,
          lineItem: orderLineItem,
          selectedVariation: selectedVariaiton_1
        });
      }), React__default.createElement("div", {
        className: styles.lineItem
      }, React__default.createElement("div", {
        className: styles.lineItemTitle
      }, React__default.createElement("strong", null, "Total")), React__default.createElement("div", {
        className: styles.lineItemPrice
      }, React__default.createElement("strong", null, numeral(totalCostBeforeTax.amount).format('$0,0.00')))))), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_EXPERIENCE_ORDER,
            orderId: orderId
          });
        }
      }, "View Charter"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading messages!");
    }
  });
};

export default InterestedInOrderConsumerMessage;
//# sourceMappingURL=index.js.map
